import type { ReactNode } from "react";

export function SideNavIconContainer({ children }: { children: ReactNode }) {
  return <div className="flex justify-center items-center">{children}</div>;
}
